import React from 'react'
import ContactCTA from '../components/ContactCTA'

const ContactPage = () => {
    return <ContactCTA />
}

export default ContactPage
